import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskAutomationCreateRoute } from '@jira/router-routes__project-settings-service-desk-automation-routes/src/projectSettingsServicedeskAutomationCreateRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskAutomationCreateRule, {
	LazyProjectSettingsServiceDeskAutomationCreateRule,
} from './ui/service-desk-automation/create-rule/index.tsx';

export const projectSettingsServicedeskAutomationCreateRouteEntry: Route = createEntry(
	projectSettingsServicedeskAutomationCreateRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		ufoName: 'service-management.automation.create-rule',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskAutomationCreateRule,
		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskAutomationCreateRule],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
